import { RoleType } from '@front/common/types'
import { hasRoles } from '@front/common/utils'
import { computed } from '@vue/composition-api'
import { useStore } from '@vueblocks/vue-use-vuex'

export default function useAuth() {
  const store = useStore()

  const auth = computed(() => {
    return store.getters['auth/get']
  })

  function userHasRoles(roles: RoleType[] = []): boolean {
    return hasRoles(auth.value?.roles, roles)
  }

  return {
    auth,
    userHasRoles,
  }
}
